import { render, staticRenderFns } from "./OsEntityToolbar.vue?vue&type=template&id=1bfe31a8&scoped=true"
import script from "./OsEntityToolbar.vue?vue&type=script&lang=ts"
export * from "./OsEntityToolbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfe31a8",
  null
  
)

export default component.exports